import type {
  ApplicationVersionResourceListResponseV2Api,
  ConfigurationModuleResourceBffItemV2Api,
  CreateConfigurationModuleV2MutationRequestApi,
  SystemPackageVersionResourceListResponseV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { ConfigurationModuleResourceSearchFront } from '@ingenico/react-configuration-generator';
import { toArray, toString } from 'lodash-es';
import type {
  ConfigurationModuleParameterSet,
  DuplicateModuleBody,
  ModuleVersion,
} from '../../models/configurationModules.model';

export function mapConfigurationModuleResourceListResponseToFront(
  data: ConfigurationModuleResourceBffItemV2Api[],
): ConfigurationModuleResourceSearchFront[] {
  return data.map((item) => ({
    id: item.id,
    configurationModuleName: item.name,
    softwareId: item.softwareVersion.softwareId,
    softwareName: item.softwareVersion.softwareName,
    softwareVersionId: item.softwareVersion.id,
    softwareVersionNumber: item.softwareVersion.softwareVersionNumber,
    logoAsset: item.softwareVersion.softwareLogo,
    type: 'CONFIGURATION_MODULE',
  }));
}

export function mapVersionsList(
  response: ApplicationVersionResourceListResponseV2Api | SystemPackageVersionResourceListResponseV2Api,
): ModuleVersion[] {
  return response.data.map((version) => ({
    id: toString(version.id),
    versionNumber: toString(version.versionNumber),
  }));
}

export function mapDuplicateBody(
  body: DuplicateModuleBody,
  parameterSets: ConfigurationModuleParameterSet[],
): CreateConfigurationModuleV2MutationRequestApi {
  return {
    name: toString(body.name),
    softwareVersion: {
      id: toString(body.softwareVersionId),
      type: body.softwareType ?? 'APPLICATION_VERSION',
    },
    parameterSets: toArray(parameterSets).map((param) => ({
      templateId: param.template.id,
      values: param.values,
    })),
  };
}
